import { MutationCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useOpenGlobalErrorModal } from "hooks/useGlobalError";
import { useMemo } from "react";
import { EntitleError } from "utils/errors/entitleError";

export const QueryClientWithErrorProvider: FC = ({ children }) => {
  const openGlobalErrorModal = useOpenGlobalErrorModal();

  const queryClient = useMemo(
    () =>
      new QueryClient({
        // UI tests only: retry: 3 with backoff makes an error-path assertion a ~7s race.
        defaultOptions: import.meta.env.DEV && (window as { __disableQueryRetry__?: boolean }).__disableQueryRetry__
          ? { queries: { refetchInterval: false, retry: false } }
          : {},
        mutationCache: new MutationCache({
          onError: (error, _variables, _context, mutation) => {
            if (mutation.options.onError) return;
            if (error instanceof EntitleError && error.suppressError) return;
            openGlobalErrorModal(error);
          },
        }),
      }),
    [openGlobalErrorModal],
  );

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
